module.exports = __webpack_public_path__ + "static/media/carousel_4.ea5e4127.jpg";